import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = ({ onSwitchToRegister }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { login, loginWithMicrosoft, error, setError } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    const result = await login(credentials);
    
    if (!result.success) {
      setIsLoading(false);
    }
    // If successful, the App component will handle the redirect
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleMicrosoftLogin = async () => {
    setIsLoading(true);
    await loginWithMicrosoft();
    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src="/lionLogo-w-document-no-background.png" 
            alt="S3 Lion Logo" 
            className="login-logo"
            onError={(e) => {
              e.target.src = "/lionLogo-w-Document.png";
            }}
          />
          <h1>S3 Lion</h1>
          <p>Document Processing System</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              required
              placeholder="Enter your username"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-input">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleInputChange}
                required
                placeholder="Enter your password"
                disabled={isLoading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading || !credentials.username || !credentials.password}
          >
            {isLoading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div className="login-divider">
          <span>or</span>
        </div>

        <button 
          type="button"
          className="microsoft-login-button"
          onClick={handleMicrosoftLogin}
          disabled={isLoading}
        >
          <svg className="microsoft-icon" viewBox="0 0 23 23">
            <path fill="#f35325" d="M0 0h11v11H0V0z"/>
            <path fill="#81bc06" d="M12 0h11v11H12V0z"/>
            <path fill="#05a6f0" d="M0 12h11v11H0V12z"/>
            <path fill="#ffba08" d="M12 12h11v11H12V12z"/>
          </svg>
          {isLoading ? 'Redirecting...' : 'Sign in with Microsoft 365'}
        </button>

        <div className="login-footer">
          <p>
            Don't have an account?{' '}
            <button 
              type="button" 
              className="link-button"
              onClick={onSwitchToRegister}
              disabled={isLoading}
            >
              Sign up here
            </button>
          </p>
        </div>

      </div>
    </div>
  );
};

export default Login;